"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftReaderWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const displayHtml_1 = __importDefault(require("../../../../../utils/displayHtml"));
const draftReaderWidget_style_1 = __importDefault(require("./draftReaderWidget.style"));
const DraftReaderWidget = ({ classes, value = '', schema = {} }) => (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: schema.title }), void 0),
        jsx_runtime_1.jsx("div", { className: classes.readOnly, 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: displayHtml_1.default(value) }, void 0)] }, void 0));
exports.DraftReaderWidget = DraftReaderWidget;
exports.default = react_jss_1.default(draftReaderWidget_style_1.default)(exports.DraftReaderWidget);
//# sourceMappingURL=index.js.map